import React from "react";
import image from "../image/probrocker-logo.png";
import image2 from "../image/thankyou.png";
import image3 from "../image/2.png";
import {
  PhoneIcon,
  EnvelopeIcon,
  MapPinIcon
} from '@heroicons/react/24/solid';





const InvoiceTemplate = ({ user = {}, item = {}, type = "subscription" }) => {
  const isAddon = type === "addon";
  
  // Calculate prices based on the item type
  const amount = Number(isAddon ? item.Amount : item.amount) || 0;
  const taxAmount = Number(isAddon ? (amount * 0.18) / 1.18 : (item.taxAmount || 0));
  const discountAmount = Number(isAddon ? 0 : (item.discountAmount || 0));
  
  const total = amount;
  const discount = discountAmount;
  const subTotal = total + discount - taxAmount;

  const orderId = isAddon ? item.razorpayOrderId : item.orderId;
  const paymentMode = isAddon ? "Razorpay" : (item.paymentMode || "UPI");
  const agentName = item.agentName || "System";
  
  const itemName = isAddon ? (item.AddonName || "Add-on") : (item.PlanName || "Premium Plan");
  const duration = isAddon 
    ? (item.FeaturesExpiredsessions?.durationInMonth || item.durationInMonth || "1")
    : (item.durationInMonth || "1");
    
  const expiryDate = isAddon
    ? (item.EndDate || item.FeaturesExpiredsessions?.expiredDate)
    : item.expiredDate;

  return (
    <div
      id="invoice-content"
      className="max-w-[700px] mx-auto bg-white border-2 mt-20 border-[#503691] rounded-lg shadow-lg p-8 font-sans"
    >
      {/* Logo */}
      <div className="flex justify-end items-center mb-2">
        <img
          src={image}
          alt="Logo"
          className="h-[53px] w-[260px] mb-1"
        />
      </div>

      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <div>
          <h2 className="text-2xl font-bold text-[#503691]">INVOICE</h2>
          <div className="text-sm mt-2">
            <div>
              Invoice Date: <span className="font-semibold">{new Date(item.createdOn || item.createdAt || new Date()).toLocaleDateString()}</span>
            </div>
          </div>
        </div>
        <div className="text-black text-sm leading-6">
          <h5 className="text-lg  text-[20px] font-semibold tracking-wide">BROX Venture PVT LTD</h5>
          <div className="text-sm text-[13px]">
            <div className="flex gap-1">
              <span className="font-semibold">CIN</span>
              <span>: U72900GJ2022PTC136928</span>
            </div>
            <div className="flex gap-1">
              <span className="font-semibold">PAN</span>
              <span>: AAJCV0940J</span>
            </div>
            <div className="">
              <a href="https://probroker.in" className="text-black hover:underline" target="_blank" rel="noopener noreferrer">
                https://probroker.in
              </a>
            </div>
          </div>
        </div>

      </div>

      {/* Bill To & Payment Info */}
      <div className="flex justify-between mb-6">
        <div>
          <div className="font-bold">BILL TO:</div>
          <div className="flex gap-1">
            <span className="font-semibold">{user?.name || "N/A"}</span>
          </div>
          
          <div className="flex gap-1">
            <span className="font-semibold">Order ID :</span>
            <span>{orderId || "N/A"}</span>
          </div>
          <div className="flex gap-1">
            <span className="">{user?.address || "N/A"}</span>
          </div>
          <div>Contact: {user?.number || user?.contactNumber || "N/A"}</div>
        </div>
        <div>
          <div className="font-bold">PAYMENT INFORMATION:</div>
          <div>
            <div className="flex gap-1">
              <span className="font-semibold">Mode :</span>
              <span> {paymentMode || "N/A"} </span>
            </div>

          </div>
          <div>
            <div className="flex gap-1">
              <span className="font-semibold">Agent Name :</span>
              <span> {agentName || "N/A"} </span>
            </div>

          </div>
        </div>
      </div>

      {/* Table */}
      <div className="border-2 border-[#503691] rounded-lg text-center overflow-hidden mb-6">
        <div className="flex bg-[#503691] text-white font-bold">
          <div className="w-1/12 p-2 border-r border-white">ITEM</div>
          <div className="w-6/12 p-2 border-r border-white">Name</div>
          <div className="w-2/12 p-2 border-r border-white">DURATION</div>
          <div className="w-3/12 p-2">AMOUNT</div>
        </div>
        <div className="flex bg-white">
          <div className="w-1/12 p-2 border-r border-[#503691]">1.</div>
          <div className="w-6/12 p-2 border-r border-[#503691]">
            {itemName}<br/> Valid Till - {expiryDate ? new Date(expiryDate).toLocaleDateString() : "N/A"}
          </div>
          <div className="w-2/12 p-2 border-r border-[#503691]">
             {duration} {isAddon ? "Unit/Month" : "Months"}
          </div>

          <div className="w-3/12 p-2">₹ {amount || "N/A"}</div>
        </div>
      </div>

      {/* Subtotal and Discount */}
      <div className="flex justify-end mb-4 ">
        <div className="w-1/3 border border-[#503691]  px-4 py-2 rounded-lg ">
          <div className="flex justify-between">
            <span>Sub Total :</span>
            <span>₹{subTotal.toLocaleString()}</span>
          </div>
          <div className="flex justify-between">
            <span>Discount :</span>
            <span>₹{discount.toLocaleString()}</span>
          </div>
          <div className="flex justify-between">
            <span>GST (18%) :</span>
            <span>₹{taxAmount.toLocaleString(undefined, {maximumFractionDigits: 2})}</span>
          </div>
        </div>
      </div>
      {/* total */}
      <div className="flex justify-end mb-2">
        <div className="bg-[#503691] text-white px-8 py-2 rounded-lg text-lg font-bold">
          TOTAL: ₹ {total.toLocaleString()}
        </div>
      </div>

      {/* Footer */}
      <div className="flex items-center mt-3">
        <div className="w-1/2">
          {/* You can use an <img> for the stamp if you have one */}
          <div className=" rounded-full w-56 h-52 flex items-center justify-center text-purple-800 font-bold text-xl">
            <img src={image3} alt="Logo" className="h-[193px] w-[190px]" />
          </div>
        </div>
        <div className="w-1/2 pl-[110px] text-right">

          <img src={image2} alt="Thank You" className="h-[190px] w-[390px]" />

        </div>
      </div>

      {/* Contact */}
      <div className="mt-2 text-sm">
        <div className="font-bold">CONTACT :</div>

        <div className="flex items-center gap-2 mt-1">
          <PhoneIcon className="h-5 w-5 text-black" />
          <span>9316066832 / 8141817353</span>
        </div>

        <div className="flex items-center gap-2 mt-1">
          <EnvelopeIcon className="h-5 w-5 text-black" />
          <span>connect@probroker.in</span>
        </div>

        <div className="flex items-start gap-2 mt-1">
          <MapPinIcon className="h-5 w-5 text-black mt-1" />
          <span>
            4<sup>th</sup> Floor, Ihub Building, Inside KCG Campus
            <br />
            Behind LD College, Navrangpura 380009
          </span>
        </div>
      </div>
    </div>
  );
};

export default InvoiceTemplate;
